var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('analyses-list',{attrs:{"analysesList":_vm.analysesList},on:{"analysis:delete":_vm.reloadAnalyses,"analysis:create":_vm.createAnalysis}})}
var staticRenderFns = []

export { render, staticRenderFns }